/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiAttributeType {
    GENERAL = 'GENERAL',
    SCHEMA_FIELD = 'SCHEMA_FIELD'
}


export function instanceOfInternalApiAttributeType(value: any): boolean {
    for (const key in InternalApiAttributeType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiAttributeType, key)) {
            if (InternalApiAttributeType[key as keyof typeof InternalApiAttributeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiAttributeTypeFromJSON(json: any): InternalApiAttributeType {
    return InternalApiAttributeTypeFromJSONTyped(json, false);
}

export function InternalApiAttributeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAttributeType {
    return json as InternalApiAttributeType;
}

export function InternalApiAttributeTypeToJSON(value?: InternalApiAttributeType | null): any {
    return value as any;
}

export function InternalApiAttributeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiAttributeType {
    return value as InternalApiAttributeType;
}

